import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'rosie-website-chat-banner',
  templateUrl: './website-chat-banner.component.html',
  styleUrls: ['./website-chat-banner.component.scss'],
  standalone: false,
})
export class WebsiteChatBannerComponent {
  @Output() dismissed = new EventEmitter<void>();

  constructor(private router: Router) {}

  dismiss(): void {
    this.dismissed.emit();
  }

  navigate(): void {
    this.router.navigate(['/settings', { section: 'website-widgets' }]);
  }
}
